import React, {Component} from 'react';
import "./index.css"
import * as _ from 'lodash';
import api from "../../../../util/clipstore/broadcaster/library";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import {GalleryVideoItem} from "../../../../components/clipstore/broadcaster/library/gallery/video-item";
import {Button, Container} from "reactstrap";
import assets from "../../../../util/assets";
import {GalleryItem} from "../../../../components/clipstore/broadcaster/library/gallery/item";
import {EditVideoModal} from "../../../../components/modal/clipstore/broadcaster/EditVideoModal";
import {GalleryModal} from "../../../../components/modal/clipstore/broadcaster/GalleryModal";

class GalleryPage extends Component {

    constructor() {
        super();

        this.state = {
            width: 96,
            height: 54,
            gallery: {
                id: "-1",
                title: '',
                videos: []
            },
            isCreateGalleryModalOpen: false,
            isEditModalOpen: false,
        }

        this.getPublishId = this.getPublishId.bind(this);
        this.setGallery = this.setGallery.bind(this);
        this.editVideo = this.editVideo.bind(this);
        this.deleteVideo = this.deleteVideo.bind(this);
        this.editGallery = this.editGallery.bind(this);
        this.deleteGallery = this.deleteGallery.bind(this);
        this.getMyGallery = this.getMyGallery.bind(this);
    }

    componentDidMount() {
        this.getMyGallery()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.get_my_gallery && nextProps.get_my_gallery.payload !== null && nextProps.get_my_gallery.payload !== this.props.get_my_gallery.payload) {
            this.setGallery(nextProps.get_my_gallery.payload)
        }

        //handle the API response for deleting the video
        api.handleAPIResponse(nextProps, "delete_videos", () => {
            //reset the payload value as we have captured the event
            this.props.resetDeleteVideos();
        }, () => {
            //this.props.history.push("/broadcaster/my-library")
            this.getMyGallery()
        }, () => {
            //nothing to handle
        })

        //handle the API response for deleting the video
        api.handleAPIResponse(nextProps, "delete_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetDeleteGallery();
        }, () => {
            this.props.history.push("/broadcaster/my-library")
            //this.getMyGallery()
        }, () => {
            //nothing to handle
        })
    }

    getPublishId() {
        const url_string = window.location.href
        const url = new URL(url_string);
        return url.searchParams.get("id");
    }

    setEditVideoModal = (isEditModalOpen) => {
        this.setState({
            isEditModalOpen
        })
    }

    setCreateGalleryModal = (isCreateGalleryModalOpen) => {
        this.setState({
            isCreateGalleryModalOpen
        })
    }

    setGallery(payload) {
        const id = this.getPublishId();
        if (payload !== null) {
            let gallery = _.filter(payload, function (content) {
                return id.indexOf(content.id) !== -1;
            });

            if (gallery !== null && Array.isArray(gallery) && gallery.length > 0) {
                this.setState({
                    gallery: gallery[0]
                }, () => {
                })
            }
        }
    }

    getMyGallery() {
        api.getMyGallery(this.props, {
            width: this.state.width,
            height: this.state.height,
        });
    }

    deleteVideo(id) {
        api.onDelete(this.props, id)
    }

    editVideo(id) {

        const result = this.state.gallery.videos.filter(content => content.id === id);

        if (Array.isArray(result) && result.length > 0) {
            this.setState({
                isEditModalOpen: true
            }, () => {
                this.props.setAddEditPricing(result[0])
            });
        }
    }

    thumbnailClicked(id) {
    }

    deleteGallery(id) {
        api.deleteGalleryAPI(this.props, id)
    }

    editGallery(id) {
        this.setCreateGalleryModal(true)
        this.props.setAddEditPricing(this.state.gallery)
    }

    render() {
        return (
            <main role="main" className="">
                <div className="broadcast-container-parent row">
                    <div className="broadcast-container other-middle-container">

                        <GalleryModal
                            isOpen={this.state.isCreateGalleryModalOpen}
                            history={this.props.history}
                            toggle={(key) => {
                                this.setCreateGalleryModal(false)

                                if (key === "refresh") {
                                    this.getMyGallery();
                                }
                            }}
                            editMode={true}
                            title={"Edit Gallery"}
                        />

                        {
                            this.state.isEditModalOpen &&
                            <EditVideoModal
                                isOpen={this.state.isEditModalOpen}
                                toggle={(key) => {
                                    this.setEditVideoModal(false);

                                    if (key === "refresh") {
                                        this.getMyGallery();
                                    }
                                }}
                                history={this.props.history}
                            />
                        }

                        {
                            this.state.gallery.id !== "-1" &&
                            <Container className="my-library-home-container no-padding">
                                <div
                                    className="display-flex-justify-video-flex-start-align-items-center gallery-title-container">
                                    <div onClick={() => {
                                        this.props.history.goBack();
                                    }} style={{cursor: 'pointer'}}>
                                        <img src={assets.clipstore.back} alt="back button"/>
                                    </div>
                                    <div className="safety-concerns-gall">
                                        {this.state.gallery.title}
                                    </div>
                                </div>
                                <div className="gallery-video-content-container">
                                    <div className="gallery-content-container">
                                        <GalleryItem
                                            index={this.state.gallery.id}
                                            deleteGallery={this.deleteGallery}
                                            editGallery={this.editGallery}
                                            thumbnailClicked={this.thumbnailClicked}
                                            gallery={this.state.gallery}

                                            delete_gallery={this.props.delete_gallery}
                                        />
                                    </div>

                                    {
                                        this.state.gallery.hasOwnProperty("videos") &&
                                        this.state.gallery.videos.length > 0 &&
                                        <div className="video-primary-text">
                                            Videos
                                        </div>
                                    }
                                    {
                                        this.state.gallery.hasOwnProperty("videos") &&
                                        this.state.gallery.videos.map((video, index) => {
                                            return (
                                                <GalleryVideoItem
                                                    index={index}
                                                    deleteVideo={this.deleteVideo}
                                                    editVideo={this.editVideo}
                                                    thumbnailClicked={this.thumbnailClicked}
                                                    video={video}

                                                    delete_videos={this.props.delete_videos}
                                                />
                                            )
                                        })
                                    }
                                </div>

                                <div className="gallery-video-content-container-footer">
                                    <Button color="primary"
                                            style={{width: 120}}
                                            onClick={() => {
                                                this.props.history.goBack();
                                            }}>
                                        BACK
                                    </Button>
                                </div>
                            </Container>
                        }
                    </div>
                </div>
            </main>
        );
    }
}

GalleryPage.propTypes = {};

function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        get_my_gallery: state.clipstore_broadcaster_get_my_gallery,
        delete_videos: state.clipstore_broadcaster_delete_videos,
        delete_gallery: state.clipstore_broadcaster_reducer_delete_gallery,
    };
}

export default connect(mapStateToProps, actions)(GalleryPage);
